export default __webpack_public_path__ + "static/media/e1-room-bg.6057b1be.jpg";